import React from 'react';
import { Badge } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const StyledBadge = withStyles(() => ({
  badge: {
    right: 6,
    fontSize: 12,
    height: 25,
    minWidth: 25,
    borderRadius: 25,
  },
}))(Badge);

const ButtonBadge = ({
  children,
  ...other
}: {
  children: React.ReactNode;
  badgeContent: React.ReactNode;
  color: 'default' | 'error' | 'primary' | 'secondary';
}): React.ReactElement => <StyledBadge {...other}>{children}</StyledBadge>;

export default ButtonBadge;
